module.exports = "<div class=\"animationload\" *ngIf=\"loading\">\n  <div class=\"osahanloading\"></div>\n</div>\n"